/* FlowCheck Supply — storefront behaviour.

   Everything here is progressive. With JS disabled the nav is visible, the
   variant radios still submit through Shopify's own form, the gallery shows
   all images stacked, and reveal-on-scroll content is simply already
   visible — which is why .reveal is only hidden once JS confirms it can
   un-hide it. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Mobile nav ─────────────────────────────────────────────────────── */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ── Search drawer ──────────────────────────────────────────────────── */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchBar = document.querySelector('[data-searchbar]');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      var open = searchBar.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var i = searchBar.querySelector('input'); if (i) i.focus(); }
    });
  }

  /* ── Announcement rotator ───────────────────────────────────────────── */
  var announceItems = document.querySelectorAll('[data-announce-item]');
  if (announceItems.length > 1 && !reduceMotion) {
    var ai = 0;
    setInterval(function () {
      announceItems[ai].classList.remove('is-active');
      ai = (ai + 1) % announceItems.length;
      announceItems[ai].classList.add('is-active');
    }, 4200);
  }

  /* ── Product gallery ────────────────────────────────────────────────── */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (full) main.src = full;
        thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  /* ── Variant picker ─────────────────────────────────────────────────────
     Shopify needs the numeric variant id in a hidden input named `id`. The
     radios carry option values, so on change we resolve the matching variant
     and write its id — then update price, stock and the button so a sold-out
     combination cannot be submitted. */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var data = form.querySelector('[data-variants]');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }

    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var button  = form.querySelector('[data-add]');
    var stockEl = document.querySelector('[data-stock]');

    function chosen() {
      return Array.prototype.map.call(form.querySelectorAll('[data-option-index]'), function (g) {
        var c = g.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function update() {
      var picked = chosen();
      var match = variants.find(function (v) {
        return picked.every(function (val, i) { return val === null || v.options[i] === val; });
      });
      if (!match) return;

      if (idInput) idInput.value = match.id;
      if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;
      if (button) {
        button.disabled = !match.available;
        button.textContent = match.available
          ? button.getAttribute('data-label-add')
          : button.getAttribute('data-label-sold');
      }
      if (stockEl) {
        stockEl.classList.toggle('stock--out', !match.available);
        stockEl.textContent = match.available
          ? stockEl.getAttribute('data-label-in')
          : stockEl.getAttribute('data-label-out');
      }
      /* Keep the URL honest so a shared link opens the variant that was on
         screen, not the first one. */
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"]')) update();
    });
    update();
  });

  /* ── Reveal on scroll ───────────────────────────────────────────────── */
  var revealables = document.querySelectorAll('.reveal');
  if (revealables.length) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealables.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      revealables.forEach(function (el) { io.observe(el); });
    }
  }
})();
